const state = {
  isLoading: false,
  data: [],
};

export default state;
